import { Component, Input, OnInit } from '@angular/core';
import { IPopoverItems } from 'src/app/interfaces/popover';

@Component({
  selector: 'app-popover',
  templateUrl: './popover.component.html',
  styleUrls: ['./popover.component.scss']
})
export class PopoverComponent implements OnInit {
  @Input() popoverId = 1
  @Input() items: Array<IPopoverItems> = []

  ngOnInit(): void {
    // do nothing
  }

  clickEvent(index: number) {
    window.addEventListener('click', function(e: any){   
      let allPopovers: any = document.getElementsByClassName('cstm-popover')
      let popoversArray = [...allPopovers]

      for ( let [index, popover] of popoversArray.entries() ) {
        if ( popover?.id !== 'cstm-popover-'+index ) {
          document.getElementById(popover?.id)?.classList.remove('curr-popover-showing')
        }
      }

      if ( !e.target.classList.contains('boton-accion') ){
        let currElement = document.getElementById('cstm-popover-'+index)
        currElement?.classList.remove('curr-popover-showing')
      }
    });
  }

  togglePopover(index: number) {
    this.clickEvent(index)

    setTimeout(() => {
      let currElement = document.getElementById('cstm-popover-'+index)
      if ( currElement?.classList?.contains('curr-popover-showing') ) {
        currElement?.classList.remove('curr-popover-showing')
      } else {
        currElement?.classList.add('curr-popover-showing')
      }
    }, 50);
  }

  clickItemFn(fn: any, index?: number) {
    fn(index)
  }

}
